<template>
    <div v-if="widgetReady" class="plan-selection">
        <div class="modal-body">
            <p class="select-info">Select members for this plan</p>
            <div class="select-form-area">
                <div class="form-check" v-for="member in membersPlanInfo" :key="member.consumerId">
                    <input :disabled="isEligible(member)" class="form-check-input" type="checkbox" :value="member.consumerId" :id="member.consumerId + planId"
                           v-model="selectedMembers">
                    <label class="form-check-label" :for="member.consumerId + planId">
                        <strong>{{ member.member }}
                            <template v-if="showPricing">{{ findMemberPrice(member) }}</template>
                        </strong>
                        <span v-if="member.currentPlan"> - Current Plan: {{ member.currentPlan.planName }}</span>
                    </label>
                </div>
            </div>
            <p>
                * By selecting this plan, you are agreeing to the specifications and services outlined in the plan description.
            </p>
        </div>
        <div class="plan-selection-buttons modal-footer">
            <button type="button" class="btn btn-danger btn-sm wl-btn-danger" data-bs-dismiss="modal">
                Cancel
            </button>
            <ac-button type="button" class="btn btn-primary btn-sm wl-btn-success" :action="validateSelection">
                Apply
            </ac-button>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {notifications} from "../../../../global/notifications.js";
    import {common} from "../../../../global/common.js";
    import {formatter} from "../../../../global/formatter.js";
    import {planPricesMixin} from "../../../../components/shared/mixins/planPricesMixin.js";

    export default {
        name: "PlanSelection",
        props: {
            plan: {type: [Object], required: true},
            consumerId: {type: [Number], required: true},
            providerEntityId: {type: [Number], required: true}
        },
        mixins: [planPricesMixin],
        data() {
            return {
                selectedMembers: [],
                planId: 0,
                widgetReady: false
            };
        },
        computed: {
            ...mapGetters(['familyMembersPlanInfo']),
            ...mapGetters({showPricing: "globalSettings/showPricing"}),
            membersPlanInfo() {
                return this.familyMembersPlanInfo.filter(x => !x.termMessage);
            },
            selectedMonthFrequency() {
                if (this.plan.monthFrequency > 0) {
                    return this.plan.monthFrequency;
                }
                const frequencies = this.plan.monthFrequencies || [];
                const firstFrequency = frequencies[0];
                if (firstFrequency && firstFrequency.monthFrequency > 0) {
                    return firstFrequency.monthFrequency;
                }
                return 1;
            },
        },
        methods: {
            async cancelSelections() {
                await this.$store.dispatch('REMOVE_ALL_CART_ITEMS', this.consumerId);
            },
            async validateSelection() {
                // console.log("validationSelection selectedMembers:", this.selectedMembers);
                if (!this.selectedMembers.length) {
                    notifications.show({title: "Error", message: "No plans are selected"}, common.ACRESSA_NOTIFICATIONS.ERROR);
                    return;
                }

                await this.$store.dispatch("ADD_ITEMS_TO_CART", {
                    mainConsumerId: this.consumerId,
                    consumerIds: this.selectedMembers,
                    planId: this.plan.planId,
                    providerEntityId: this.providerEntityId,
                    monthFrequency: this.selectedMonthFrequency,
                    planCategoryId: this.plan.planCategoryId,
                    planName: this.plan.planName,
                    isFamilyPlan: Boolean(this.plan.familyPlan),
                });

                $('.modal').modal('hide');
                this.$router.push({name: "checkout", params: {consumerId: this.consumerId}});
            },
            isEligible(member) {
                let eligible = this.findMemberPrice(member);
                if (eligible == "Ineligible") {
                    return true
                }
                return false
            }
        },
        mounted() {
            this.planId = this.plan.planId;
            this.widgetReady = true;
        }
    }
</script>

<style scoped>
    .plan-selection {
        z-index: 9999;
        padding-top: 10px;
        text-align: left;
    }

    .select-form-area {
        margin-bottom: 15px;
    }

    .select-info {
        font-weight: bold;
    }

    .form-check label {
        height: 30px;
    }

    .plan-selection-buttons {
        padding-top: 10px;
    }
</style>